
import React ,{ Component } from 'react';
import {Container, Row, Col,Image,Button,Form,Card,InputGroup,Collapse  } from 'react-bootstrap';
import "./cadreRegistration.css";
import { withRouter,Link } from "react-router-dom";
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import loader from '../../images/loader.gif';
import { getAPICallDataForOnlyBSA } from '../../services/MemberService';
import { getAPICallDataForCadre } from '../../services/MemberService';
import { getAPICallDataForCadreSaving } from '../../services/MemberService';
import ChangeMobileNoOTPValidation from './ChangeMobileNoOTPValidation';
import { scroller } from "react-scroll";

//const fetch = require('node-fetch');

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };

class DonationAmountPage extends Component {
    constructor(props) {
        super(props)
        

        this.state = {
            chatID: window.User !=undefined ? window.User.chatID : "943827154",
            englishSelected:props?.location?.params?.englishSelected == undefined ? true : this.props?.location?.params?.englishSelected,
            teleguSelected:props?.location?.params?.teleguSelected == undefined ? false : this.props?.location?.params?.teleguSelected,

            ap_listArr:[],
            constituencyValue:"",
            constituencyName:"",
            
            captureMobileNo:"",
            validateCaptureMobileNo:"",
            captureOTPNO:"",
            validateCaptureOTP:"",

            mobileNoDisabled:false,
            otpBlockShow:false,

            smsSentMessage:"",
            otpVerifiedMessageStatus:"",
            otpLoadingSymbol:"hide",
            getOTPLoadingSymbol:"hide",
            OTPSentStatus:"",
            resendOTPLoadingSymbol:"hide",
            resendSmsSentMessage:"",

            mobileNoLoadingSymbol:"hide",
            mobileNoSuccessMsg:"",
            
            minutes:1,
            seconds:0,
            OTPVerifiedDisabledButton:true,
            
            searchRenewalMembershipId:"",
            searchRenewalMobileNo:"",
            searchRenewalVoterId:"",
            userDetailsError:"",

            renewalDetailsLoading:"hide",
            renewalDetailsArr:[],
            renewalDetailsDataCheck:0,

            donationFirstPage:true,
            donationSecondPage:false,
            haveMemberShipIdCheck:false,
            noMemberShipIdCheck:false,

            donationName:"",
            donationGenderValue:"",
            donationGender:"",
            donationGenderArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
            donationAge:"",
            donationHouseNo:"",
            validateDonationHouseNo:"",
            donationStreetName:"",
            validateDonationStreetName:"",
            donationVillageTown:"",
            validateDonationVillageTown:"",

            paynowDonationButtonLoadingSymbol:"hide",
            paynowDonationButtonDisabled:false,
            paynowDonationSuccessMessage:"",
            donationAmountValue:"",
            validateDonationAmount:"",
            donationPinCode:"",
            validateDonationPinCode:"",

            stateSelectedArr:[{'value':'1','label':'Andhra Pradesh'},{'value':"36",'label':'Telangana'},{'value':"37",'label':'Others'}],
            stateSelectedValue:{'value':'1','label':'Andhra Pradesh'},
            stateSelected:"1",
            validatestateSelected:"",

            constituencySelectedValue:"",
            constituencySelected:"",
            constituencySelectedArr:[{'value':'181','label':'ACHANTA'},{'value':'218','label':'ADDANKI'},{'value':'253','label':'ADONI'},{'value':'254','label':'ALLAGADDA'},{'value':'255','label':'ALUR'},{'value':'108','label':'AMADALAVALASA'},{'value':'146','label':'AMALAPURAM'},{'value':'133','label':'ANAKAPALLI'},{'value':'298','label':'ANANTAPUR URBAN'},{'value':'147','label':'ANAPARTHY'},{'value':'359','label':'ARAKU VALLEY'},{'value':'241','label':'ATMAKUR'},{'value':'182','label':'AVANIGADDA'},{'value':'242','label':'BADVEL'},{'value':'333','label':'BANAGANAPALLE'},{'value':'209','label':'BAPATLA'},{'value':'167','label':'BHIMAVARAM'},{'value':'368','label':'BHIMILI'},{'value':'122','label':'BOBBILI'},{'value':'280','label':'CHANDRAGIRI'},{'value':'120','label':'CHEEPURUPALLI'},{'value':'199','label':'CHILAKALURIPET'},{'value':'168','label':'CHINTALAPUDI'},{'value':'219','label':'CHIRALA'},{'value':'281','label':'CHITTOOR'},{'value':'134','label':'CHODAVARAM'},{'value':'221','label':'DARSI'},{'value':'169','label':'DENDULUR'},{'value':'267','label':'DHARMAVARAM'},{'value':'257','label':'DHONE'},{'value':'135','label':'ELAMANCHILI'},{'value':'170','label':'ELURU'},{'value':'109','label':'ETCHERLA'},{'value':'121','label':'GAJAPATHINAGARAM'},{'value':'358','label':'GAJUWAKA'},{'value':'301','label':'GANGADHARA NELLORE'},{'value':'310','label':'GANNAVARAM (EG)'},{'value':'184','label':'GANNAVARAM (KRISHNA)'},{'value':'222','label':'GIDDALUR'},{'value':'171','label':'GOPALPURAM'},{'value':'185','label':'GUDIVADA'},{'value':'231','label':'GUDUR'},{'value':'297','label':'GUNTAKAL'},{'value':'311','label':'GUNTUR EAST'},{'value':'312','label':'GUNTUR WEST'},{'value':'203','label':'GURZALA'},{'value':'270','label':'HINDUPUR'},{'value':'111','label':'ICHAPURAM'},{'value':'149','label':'JAGGAMPETA'},{'value':'186','label':'JAGGAYYAPET'},{'value':'244','label':'JAMMALAMADUGU'},{'value':'243','label':'KADAPA'},{'value':'271','label':'KADIRI'},{'value':'187','label':'KAIKALUR'},{'value':'308','label':'KAKINADA CITY'},{'value':'307','label':'KAKINADA RURAL'},{'value':'272','label':'KALYANDURG'},{'value':'245','label':'KAMALAPURAM'},{'value':'223','label':'KANDUKUR'},{'value':'224','label':'KANIGIRI'},{'value':'232','label':'KAVALI'},{'value':'258','label':'KODUMUR'},{'value':'246','label':'KODUR'},{'value':'225','label':'KONDEPI'},{'value':'152','label':'KOTHAPETA'},{'value':'233','label':'KOVUR'},{'value':'172','label':'KOVVUR'},{'value':'282','label':'KUPPAM'},{'value':'260','label':'KURNOOL'},{'value':'360','label':'KURUPAM'},{'value':'205','label':'MACHERLA'},{'value':'328','label':'MACHILIPATNAM'},{'value':'273','label':'MADAKASIRA'},{'value':'294','label':'MADANPALLE'},{'value':'136','label':'MADUGULA'},{'value':'309','label':'MANDAPETA'},{'value':'206','label':'MANGALAGIRI'},{'value':'334','label':'MANTRALAYAM'},{'value':'226','label':'MARKAPUR'},{'value':'153','label':'MUMMIDIVARAM'},{'value':'249','label':'MYDUKUR'},{'value':'191','label':'MYLAVARAM'},{'value':'283','label':'NAGARI'},{'value':'192','label':'NANDIGAMA'},{'value':'261','label':'NANDIKOTKUR'},{'value':'262','label':'NANDYAL'},{'value':'112','label':'NARASANNAPETA'},{'value':'173','label':'NARASAPUR'},{'value':'208','label':'NARASARAOPET'},{'value':'137','label':'NARSIPATNAM'},{'value':'361','label':'NELLIMARLA'},{'value':'340','label':'NELLORE CITY'},{'value':'341','label':'NELLORE RURAL'},{'value':'366','label':'NIDADAVOLE'},{'value':'193','label':'NUZVID'},{'value':'227','label':'ONGOLE'},{'value':'138','label':'PADERU'},{'value':'174','label':'PALACOLE'},{'value':'113','label':'PALAKONDA'},{'value':'284','label':'PALAMANER'},{'value':'352','label':'PALASA'},{'value':'329','label':'PAMARRU'},{'value':'263','label':'PANYAM'},{'value':'228','label':'PARCHUR'},{'value':'124','label':'PARVATHIPURAM'},{'value':'114','label':'PATHAPATNAM'},{'value':'264','label':'PATTIKONDA'},{'value':'140','label':'PAYAKARAOPETA'},{'value':'327','label':'PEDANA'},{'value':'210','label':'PEDDAKURAPADU'},{'value':'155','label':'PEDDAPURAM'},{'value':'330','label':'PENAMALURU'},{'value':'141','label':'PENDURTHI'},{'value':'275','label':'PENUKONDA'},{'value':'285','label':'PILERU'},{'value':'156','label':'PITHAPURAM'},{'value':'176','label':'POLAVARAM'},{'value':'211','label':'PONNUR'},{'value':'157','label':'PRATHIPAD'},{'value':'212','label':'PRATHIPADU'},{'value':'250','label':'PRODDATUR'},{'value':'251','label':'PULIVENDLA'},{'value':'286','label':'PUNGANUR'},{'value':'302','label':'PUTHALAPATTU'},{'value':'300','label':'PUTTAPARTHI'},{'value':'304','label':'RAJAHMUNDRY CITY'},{'value':'305','label':'RAJAHMUNDRY RURAL'},{'value':'353','label':'RAJAM'},{'value':'252','label':'RAJAMPET'},{'value':'303','label':'RAJANAGARAM'},{'value':'159','label':'RAMACHANDRAPURAM'},{'value':'306','label':'RAMPACHODAVARAM'},{'value':'299','label':'RAPTADU'},{'value':'248','label':'RAYACHOTY'},{'value':'276','label':'RAYADURG'},{'value':'160','label':'RAZOLE'},{'value':'213','label':'REPALLE'},{'value':'125','label':'SALUR'},{'value':'229','label':'SANTHANUTHALAPADU'},{'value':'236','label':'SARVEPALLI'},{'value':'214','label':'SATTENAPALLI'},{'value':'288','label':'SATYAVEDU'},{'value':'277','label':'SINGANAMALA'},{'value':'116','label':'SRIKAKULAM'},{'value':'289','label':'SRIKALAHASTI'},{'value':'332','label':'SRISAILAM'},{'value':'127','label':'SRUNGAVARAPUKOTA'},{'value':'237','label':'SULLURPET'},{'value':'177','label':'TADEPALLIGUDEM'},{'value':'215','label':'TADIKONDA'},{'value':'278','label':'TADPATRI'},{'value':'178','label':'TANUKU'},{'value':'117','label':'TEKKALI'},{'value':'216','label':'TENALI'},{'value':'290','label':'THAMBALLAPALLE'},{'value':'291','label':'TIRUPATI'},{'value':'194','label':'TIRUVURU'},{'value':'163','label':'TUNI'},{'value':'238','label':'UDAYAGIRI'},{'value':'179','label':'UNDI'},{'value':'180','label':'UNGUTUR'},{'value':'279','label':'URAVAKONDA'},{'value':'217','label':'VEMURU'},{'value':'239','label':'VENKATAGIRI'},{'value':'331','label':'VIJAYAWADA CENTRAL'},{'value':'195','label':'VIJAYAWADA EAST'},{'value':'196','label':'VIJAYAWADA WEST'},{'value':'207','label':'VINUKONDA'},{'value':'354','label':'VISAKHAPATNAM EAST'},{'value':'356','label':'VISAKHAPATNAM NORTH'},{'value':'355','label':'VISAKHAPATNAM SOUTH'},{'value':'357','label':'VISAKHAPATNAM WEST'},{'value':'129','label':'VIZIANAGARAM'},{'value':'265','label':'YEMMIGANUR'},{'value':'344','label':'YERRAGONDAPALEM'}],
            validateconstituencySelected:"",

            telconstituencySelectedValue:"",
            telconstituencySelected:"",
            telconstituencySelectedArr:[{'value':'61','label':'ACHAMPET'},{'value':'1','label':'ADILABAD'},{'value':'74','label':'ALAIR'},{'value':'62','label':'ALAMPUR'},{'value':'315','label':'AMBERPET'},{'value':'32','label':'ANDOLE'},{'value':'10','label':'ARMOOR'},{'value':'2','label':'ASIFABAD'},{'value':'326','label':'ASWARAOPET'},{'value':'313','label':'BAHADURPURA'},{'value':'11','label':'BALKONDA'},{'value':'12','label':'BANSWADA'},{'value':'295','label':'BELLAMPALLI'},{'value':'100','label':'BHADRACHALAM'},{'value':'75','label':'BHONGIR'},{'value':'365','label':'BHUPALPALLE'},{'value':'3','label':'BOATH'},{'value':'13','label':'BODHAN'},{'value':'43','label':'CHANDRAYANGUTTA'},{'value':'44','label':'CHARMINAR'},{'value':'4','label':'CHENNUR'},{'value':'55','label':'CHEVELLA'},{'value':'20','label':'CHOPPADANDI'},{'value':'369','label':'DEVARKADRA'},{'value':'77','label':'DEVERKONDA'},{'value':'322','label':'DHARMAPURI'},{'value':'86','label':'DORNAKAL'},{'value':'336','label':'DUBBAK'},{'value':'63','label':'GADWAL'},{'value':'34','label':'GAJWEL'},{'value':'87','label':'GHANPUR'},{'value':'317','label':'GOSHAMAHAL'},{'value':'320','label':'HUSNABAD'},{'value':'21','label':'HUZURABAD'},{'value':'339','label':'HUZURNAGAR'},{'value':'56','label':'IBRAHIMPATNAM'},{'value':'64','label':'JADCHERLA'},{'value':'23','label':'JAGTIAL'},{'value':'89','label':'JANGAON'},{'value':'314','label':'JUBILEE HILLS'},{'value':'15','label':'JUKKAL'},{'value':'65','label':'KALWAKURTHI'},{'value':'16','label':'KAMAREDDY'},{'value':'24','label':'KARIMNAGAR'},{'value':'46','label':'KARWAN'},{'value':'47','label':'KHAIRATABAD'},{'value':'101','label':'KHAMMAM'},{'value':'5','label':'KHANAPUR'},{'value':'78','label':'KODAD'},{'value':'66','label':'KODANGAL'},{'value':'67','label':'KOLLAPUR'},{'value':'321','label':'KORATLA'},{'value':'102','label':'KOTHAGUDEM'},{'value':'346','label':'KUKATPALLY'},{'value':'348','label':'LAL BAHADUR NAGAR'},{'value':'103','label':'MADHIRA'},{'value':'91','label':'MAHBUBABAD'},{'value':'68','label':'MAHBUBNAGAR'},{'value':'349','label':'MAHESWARAM'},{'value':'69','label':'MAKTHAL'},{'value':'49','label':'MALAKPET'},{'value':'367','label':'MALKAJGIRI'},{'value':'319','label':'MANAKONDUR'},{'value':'296','label':'MANCHERIAL'},{'value':'26','label':'MANTHANI'},{'value':'35','label':'MEDAK'},{'value':'57','label':'MEDCHAL'},{'value':'79','label':'MIRYALGUDA'},{'value':'6','label':'MUDHOLE'},{'value':'92','label':'MULUG'},{'value':'80','label':'MUNGODE'},{'value':'50','label':'MUSHEERABAD'},{'value':'338','label':'NAGARJUNA SAGAR'},{'value':'70','label':'NAGARKURNOOL'},{'value':'81','label':'NAKREKAL'},{'value':'82','label':'NALGONDA'},{'value':'316','label':'NAMPALLY'},{'value':'36','label':'NARAYANKHED'},{'value':'335','label':'NARAYANPET'},{'value':'93','label':'NARSAMPET'},{'value':'37','label':'NARSAPUR'},{'value':'7','label':'NIRMAL'},{'value':'343','label':'NIZAMABAD RURAL'},{'value':'342','label':'NIZAMABAD URBAN'},{'value':'104','label':'PALAIR'},{'value':'362','label':'PALAKURTHI'},{'value':'58','label':'PARGI'},{'value':'94','label':'PARKAL'},{'value':'337','label':'PATANCHERU'},{'value':'30','label':'PEDDAPALLI'},{'value':'324','label':'PINAPAKA'},{'value':'345','label':'QUTHBULLAPUR'},{'value':'351','label':'RAJENDRANAGAR'},{'value':'318','label':'RAMAGUNDAM'},{'value':'51','label':'SANATHNAGAR'},{'value':'39','label':'SANGAREDDY'},{'value':'105','label':'SATHUPALLI'},{'value':'52','label':'SECUNDERABAD'},{'value':'53','label':'SECUNDERABAD CANTONMENT'},{'value':'350','label':'SERLINGAMPALLY'},{'value':'71','label':'SHADNAGAR'},{'value':'40','label':'SIDDIPET'},{'value':'31','label':'SIRCILLA'},{'value':'8','label':'SIRPUR'},{'value':'84','label':'SURYAPET'},{'value':'59','label':'TANDUR'},{'value':'85','label':'TUNGATURTHI'},{'value':'347','label':'UPPAL'},{'value':'323','label':'VEMULAWADA'},{'value':'60','label':'VIKARABAD'},{'value':'73','label':'WANAPARTHY'},{'value':'364','label':'WARANGAL EAST'},{'value':'363','label':'WARANGAL WEST'},{'value':'97','label':'WARDHANNAPET'},{'value':'325','label':'WYRA'},{'value':'54','label':'YAKUTPURA'},{'value':'107','label':'YELLANDU'},{'value':'18','label':'YELLAREDDY'},{'value':'41','label':'ZAHIRABAD'}],
            telvalidateconstituencySelected:"",

            otherStateConstituencyName:"",

            donationPanNumber:"",
            validatePanCardNumber:"",

            donationInputObj:{
                "cid" : "",
                "mobileNo" : "",
                "donarName" : "",
                "amount" : 0,
                "stateId" : 0,
                "panNumber" : "",
                "transactionId" : "",
                "orderId" : "",
                "houseNo":"",
                "streetName":"",
                "villageName":"",
                "constituencyId":"",
                "constituencyName":"",
                "pincode":"",
                "volunteerMobileNo" : "",
                "source" : "TBot"
            },

            validateDonationAge:"",
            validateDonationGender:"",
            validateDonationName:"",

            volunteerMobileNoInput:"",
            enrollType:"",
            isSkipOTP:"N"

        }
    }

    componentDidMount() {
        
       
    }

    emptyDonationValues = () => {
        this.setState({
            captureMobileNo:"",
            validateCaptureMobileNo:"",
            captureOTPNO:"",
            validateCaptureOTP:"",

            mobileNoDisabled:false,
            otpBlockShow:false,

            smsSentMessage:"",
            otpVerifiedMessageStatus:"",
            otpLoadingSymbol:"hide",
            getOTPLoadingSymbol:"hide",
            OTPSentStatus:"",
            resendOTPLoadingSymbol:"hide",
            resendSmsSentMessage:"",

            mobileNoLoadingSymbol:"hide",
            mobileNoSuccessMsg:"",
            
            minutes:1,
            seconds:0,
            OTPVerifiedDisabledButton:true,
            
            searchRenewalMembershipId:"",
            searchRenewalMobileNo:"",
            searchRenewalVoterId:"",
            userDetailsError:"",

            renewalDetailsLoading:"hide",
            renewalDetailsArr:[],
            renewalDetailsDataCheck:0,

           
            donationName:"",
            donationGenderValue:"",
            donationGender:"",
            donationGenderArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
            donationAge:"",
            donationHouseNo:"",
            validateDonationHouseNo:"",
            donationStreetName:"",
            validateDonationStreetName:"",
            donationVillageTown:"",
            validateDonationVillageTown:"",

            paynowDonationButtonLoadingSymbol:"hide",
            paynowDonationButtonDisabled:false,
            paynowDonationSuccessMessage:"",
            donationAmountValue:"",
            validateDonationAmount:"",
            donationPinCode:"",
            validateDonationPinCode:"",

            stateSelectedArr:[{'value':'1','label':'Andhra Pradesh'},{'value':"36",'label':'Telangana'},{'value':"37",'label':'Others'}],
            stateSelectedValue:{'value':'1','label':'Andhra Pradesh'},
            stateSelected:"1",
            validatestateSelected:"",

            constituencySelectedValue:"",
            constituencySelected:"",
            validateconstituencySelected:"",

            telconstituencySelectedValue:"",
            telconstituencySelected:"",
            telvalidateconstituencySelected:"",

            otherStateConstituencyName:"",

            donationPanNumber:"",
            validatePanCardNumber:"",

            donationInputObj:{
                "cid" : "",
                "mobileNo" : "",
                "donarName" : "",
                "amount" : 0,
                "stateId" : 0,
                "panNumber" : "",
                "transactionId" : "",
                "orderId" : "",
                "houseNo":"",
                "streetName":"",
                "villageName":"",
                "constituencyId":"",
                "constituencyName":"",
                "pincode":"",
                "volunteerMobileNo" : "",
                "source" : "TBot"
            },

            validateDonationAge:"",
            validateDonationGender:"",
            validateDonationName:"",

            volunteerMobileNoInput:"9948029998",
            enrollType:""

        })
    }

    backToNewCadreEnrollPage = () => {
        this.props.history.push({
            pathname: "/cadre_registration",
            params: {
                navbarDisplay:"hide",
                //userAccessList:this.props?.location?.params?.userAccessList == undefined ? "" : this.props?.location?.params?.userAccessList
              },
          });
    }

    getMobileNoOTP = () => {
        this.setState({validateCaptureMobileNo:"",validateCaptureOTP:"" });
       
        var expr = /^(0|91)?[6-9][0-9]{9}$/;
    
        if(this.state.captureMobileNo == ""){
            this.setState({validateCaptureMobileNo:"Please Enter Mobile No" });
            return;
        }
    
        if(!expr.test(this.state.captureMobileNo)){
            this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No" });
            return;
        }
    
        if(this.state.captureMobileNo.length < 10){
            this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No" });
            return;
        }
    
    
        this.setState({smsSentMessage:"",getOTPLoadingSymbol:"show",OTPSentStatus:"",otpVerifiedValue:0});
        
        const obj =  
            JSON.stringify({ 
            "chatId" :this.state.chatID,
            "mobileNo" : this.state.captureMobileNo,
            "volunteerMobileNo" : this.state.volunteerMobileNoInput,
            
            }); 
    
            getAPICallDataForOnlyBSA(obj,"sendOTPForDonation")
            .then((res) => res.json())
            .then((data) => {
            this.setState({getOTPLoadingSymbol:"hide"});
            if(data !=null && data.status == "Success"){
               // console.log(jwt_decode(data.reference).sub)
                this.setState({smsSentMessage:"OTP Sent Your Mobile No",OTPSentStatus:data.status,otpVerifiedValue:1});
                this.setState({OTPVerifiedDisabledButton:false,mobileNoDisabled:true})
                this.OTPTimerFunction();
            }else if(data !=null && data.status == "Fail"){
                this.setState({smsSentMessage:data.message,OTPSentStatus:"Fail",otpVerifiedValue:0});
                this.setState({OTPVerifiedDisabledButton:true})
            }else{
                this.setState({smsSentMessage:"Some Thing Went Wrong,Please Try Again...",OTPSentStatus:"Fail",otpVerifiedValue:0});
                this.setState({OTPVerifiedDisabledButton:true})
            }
            });
    }
    
    resendOTPTimer = () => {
        this.setState({minutes:1});
        this.setState({seconds:0});
    
        this.OTPTimerFunction();
    };
    
    OTPTimerFunction = () => {
        const interval = setInterval(() => {
            if (this.state.seconds > 0) {
            this.setState({seconds:this.state.seconds - 1});
            }
    
            if (this.state.seconds === 0) {
            if (this.state.minutes === 0) {
                clearInterval(interval);
            } else {
                this.setState({seconds:90});
                this.setState({minutes:this.state.minutes - 1});
    
            }
            }
        }, 1000);
    
        return () => {
            clearInterval(interval);
        };
    }
    
    resendOTPNew = () => {
        this.setState({validateCaptureMobileNo:"",OTPVerifiedDisabledButton:false });
        if(this.state.captureMobileNo == ""){
            this.setState({validateCaptureMobileNo:"Please Enter Mobile No" });
            return;
        }
        var expr = /^(0|91)?[6-9][0-9]{9}$/;
        if(!expr.test(this.state.captureMobileNo)){
            this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No" });
            return;
        }
    
        
    
        if(this.state.captureMobileNo.length < 10){
            this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No" });
            return;
        }
    
        this.setState({resendOTPLoadingSymbol:"show",otpVerifiedValue:0});
    
        const obj =  
            JSON.stringify({ 
               "chatId" :this.state.chatID,
                "mobileNo" : this.state.captureMobileNo,
                "volunteerMobileNo" : this.state.volunteerMobileNoInput,
            
            }); 
    
            getAPICallDataForOnlyBSA(obj,"sendOTPForDonation")
            .then((res) => res.json())
            .then((data) => {
            this.setState({resendOTPLoadingSymbol:"hide"});
            if(data !=null && data.status == "Success"){
                //console.log(jwt_decode(data.reference).sub)
                this.setState({otpVerifiedValue:1});
                this.resendOTPTimer();
            }else{
                this.setState({otpVerifiedValue:0});
            }
            });
        
    }
    
    validateMobileOtp = (otp) => {
        this.setState({validateCaptureOTP:"" });
    this.setState({otpVerifiedMessageStatus:"",otpLoadingSymbol:"show"});
    const obj =  
        JSON.stringify({ 
        "chatId" :this.state.chatID,
        "mobileNo" : this.state.captureMobileNo,
        "otp" : otp,
        "volunteerMobileNo" : this.state.volunteerMobileNoInput,
        
    
        }); 
    
        getAPICallDataForOnlyBSA(obj,"verifyOTPForDonation")
        .then((res) => res.json())
        .then((data) => {
        this.setState({otpLoadingSymbol:"hide"});
        if(data !=null && data.status == "Success"){
            this.setState({otpVerifiedMessageStatus:"Verified",OTPVerifiedDisabledButton:true,mobileNoDisabled:true});
        }else{
            this.setState({otpVerifiedMessageStatus:"NotVerified",OTPVerifiedDisabledButton:false});
        }
        });
    }

    haveMemberShipIdClick = (type) => {
        this.emptyDonationValues();
        
        this.setState({donationFirstPage:true,donationSecondPage:false})
        if(type == "yes"){
            this.setState({haveMemberShipIdCheck:true,noMemberShipIdCheck:false,enrollType:""})
        }else{
            this.setState({haveMemberShipIdCheck:false,noMemberShipIdCheck:true, enrollType:"newEnroll"})
        }
      }

      donationAmountSeletedType = (e,donAmount) => {
        this.setState({validateDonationAmount:""});
        if(donAmount == "other_amount"){
            this.setState({otherDonationAmount:true,donationAmountValue:""})
        }else{
            this.setState({otherDonationAmount:false,donationAmountValue:donAmount})
        }
      }

    donationSecondPageView = (data) => {

        console.log("data",data)

         this.emptyDonationValues();
         this.setState({donationFirstPage:false,donationSecondPage:true});
         this.setState({captureMobileNo:data.mobileNo});
         if(data.mobileNo != ""){
            this.setState({mobileNoDisabled:true})
         }
        

         setTimeout(() => {
            this.setState(Object.assign(this.state.donationInputObj,{
                cid: data.cid,
                mobileNo:data.mobileNo,
                donarName:data.cname}));

        }, 1000);
      }

      changeMobileNo = () => {
        this.setState({
            validateCaptureMobileNo:"",
            captureOTPNO:"",
            validateCaptureOTP:"",
    
            mobileNoDisabled:false,
            otpBlockShow:false,
    
            smsSentMessage:"",
            otpVerifiedMessageStatus:"",
            otpLoadingSymbol:"hide",
            getOTPLoadingSymbol:"hide",
            OTPSentStatus:"",
            resendOTPLoadingSymbol:"hide",
            resendSmsSentMessage:"",
    
           
            
            minutes:1,
            seconds:0,
            OTPVerifiedDisabledButton:true,
        });

      }

      
    
      donationPreviousPage = () => {
        this.setState({donationFirstPage:true,donationSecondPage:false})
      }


    handleOnchangeInputBox = (e) => {
        console.log("handleInputChange", e.target.name, e.target.value)
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            searchRenewalMembershipId: name === "membershipId" ? value : "",
            searchRenewalMobileNo: name === "mobileNo" ? value : "",
            searchRenewalVoterId: name === "voterId" ? value : "",
            userDetailsError: "",
            submitUserIds:false

        });

        if(name == "captureOTPNO"){
            this.setState({otpVerifiedMessageStatus:"",otpLoadingSymbol:"show"});
            if(value.length >= 6){
                this.validateMobileOtp(value);
               
            }
            
        }

        this.setState({ [name]: value });
        
      }
    
handleOnchangeSelectBoxNew = (ename, evalue) =>{
    const name = ename;
    const value = evalue;

    if(name == "constituencyName"){

        let getConsIdName = this.state.ap_listArr.find((a) => a.value == value);
            this.setState({
                constituencyValue: {
                value: getConsIdName.value,
                label: getConsIdName.label
            }
        });

        this.getMandalsAndTownsByConstituencyId(value)
        
       
    }else  if(name == "donationGender"){
        let getGenderIdName = this.state.donationGenderArr.find((a) => a.value == value);
            this.setState({
                donationGenderValue: {
                value: getGenderIdName.value,
                label: getGenderIdName.label,
            }
        });
    }else  if(name == "stateSelected"){
        let getIdName = this.state.stateSelectedArr.find((a) => a.value == value);
            this.setState({
                stateSelectedValue: {
                value: getIdName.value,
                label: getIdName.label,
            }
        });

        this.setState({constituencySelectedValue:"",constituencySelected:"",telconstituencySelected:"",telconstituencySelectedValue:"",otherStateConstituencyName:""})
    }else if(name == "constituencySelected"){
        let getIdName = this.state.constituencySelectedArr.find((a) => a.value == value);
            this.setState({
                constituencySelectedValue: {
                value: getIdName.value,
                label: getIdName.label,
            }
        });
    }else if(name == "telconstituencySelected"){
        let getIdName = this.state.telconstituencySelectedArr.find((a) => a.value == value);
            this.setState({
                telconstituencySelectedValue: {
                value: getIdName.value,
                label: getIdName.label,
            }
        });
    }
      

    this.setState({ [name]: value});
  }


  submitUserIds = (e) => {

    const { searchRenewalMobileNo, searchRenewalVoterId, searchRenewalMembershipId } = this.state;

    if (!searchRenewalMobileNo && !searchRenewalVoterId && !searchRenewalMembershipId) {
        this.setState({
            userDetailsError: "Enter any of the inputs"
        });
        return;
    } else {
        this.setState({
            userDetailsError: "",
            submitUserIds:true
        });

        if(searchRenewalMembershipId !="" && searchRenewalMobileNo == "" && searchRenewalVoterId == ""){
            if(this.state.searchRenewalMembershipId.length < 8){
                this.setState({
                    userDetailsError: "Please Enter 8 Digits Valid Membership Id"
                });
                return;
            }
        }else if(searchRenewalMembershipId =="" && searchRenewalMobileNo != "" && searchRenewalVoterId == ""){
            var expr = /^(0|91)?[6-9][0-9]{9}$/;

            if(this.state.searchRenewalMobileNo == ""){
                this.setState({userDetailsError:"Please Enter Mobile No" });
                return;
            }

            if(!expr.test(this.state.searchRenewalMobileNo)){
                this.setState({userDetailsError:"Please Enter Valid Mobile No" });
                return;
            }

            if(this.state.searchRenewalMobileNo.length < 10){
                this.setState({userDetailsError:"Please Enter Valid Mobile No" });
                return;
            }
        }

        console.log("dddsdsafsafs",searchRenewalMobileNo,searchRenewalVoterId,searchRenewalMembershipId)

        this.getCitVlorSearchDetails(searchRenewalMobileNo,searchRenewalVoterId,searchRenewalMembershipId);

    }
}

getCitVlorSearchDetails = (mobileNo,vno,mid) => {
    
    this.setState({renewalDetailsLoading:"show",renewalDetailsArr:[],renewalDetailsDataCheck:0});

    const obj =  
        JSON.stringify({ 
            "mid" : mid,
            "mobileNo" : mobileNo,
            "vno" : vno,
            "username" : "app_api_cadre",
            "password" : "6Da3!p#w$5xqinRk"
        });

        getAPICallDataForCadre(obj,"getCitVlorSearchDetails")
        .then((res) => res.json())
        .then((content) => {
            this.setState({renewalDetailsLoading:"hide"})
            if(content !=null && content.length>0){
                this.setState({renewalDetailsArr:content,renewalDetailsDataCheck:0});
            }else{
                this.setState({renewalDetailsArr:"",renewalDetailsDataCheck:1});
            }
        });
    
    
}

handleOnchangeAllowNumbersInputBox = (e) => {
    this.setState({validateDonationAmount:"",validateCaptureMobileNo:""});
    const name = e.target.name;
    const value = e.target.value;
    const re = /^[0-9\b]+$/;

    if(name == "donationAmountValue"){
        if (!re.test(e.target.value)) {
            this.setState({validateInterests:"Please Enter Numbers Only...  ",donationAmountValue:"" });
            return;
        }else{
            this.setState({validateDonationAmount:"" });
        }
    }else if(name == "captureMobileNo"){
        if (!re.test(e.target.value)) {
            this.setState({validateCaptureMobileNo:"Please Enter Numbers Only...  ",captureMobileNo:"" });
            return;
        }else{
            this.setState({validateCaptureMobileNo:"" });
        }
    }
    
    
}

donationWithOutMemberShip = () => {
  
    this.paymentSuccessMessage();
}

mobileNoValidation = () => {
    console.log("this.state.otpVerifiedMessageStatus",this.state.otpVerifiedMessageStatus)
    if(this.state.captureMobileNo == ""){
        this.setState({validateCaptureMobileNo:"Please Enter Mobile No"});
        return;
    }
    if(!this.state.captureMobileNo.match(/^[0-9]+$/)){
        this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No"});
        return;
    }

    if(this.state.captureMobileNo.length < 10){
        this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No"});
        return;
    }

    if(this.state.captureMobileNo != ""){
        if(this.state.captureOTPNO == ""){
            this.setState({validateCaptureOTP:"Please Enter OTP"});
            return;
        }

        if(this.state.captureOTPNO.length < 6){
            this.setState({validateCaptureOTP:"Please Enter Valid OTP"});
            return;
        }

        if(this.state.otpVerifiedMessageStatus == "NotVerified"){
            this.setState({validateCaptureOTP:"Please Enter Valid OTP"});
            return;
        }
    }
}

scrollTop = () => {
    scroller.scrollTo("scroll_top_mobile", { 
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
    });
}

paymentSuccessMessage = () => {
    this.setState({validateDonationAmount:"",validatePanCardNumber:"",paynowDonationSuccessMessage:"",validatestateSelected:"",
        validateDonationName:"",validateDonationHouseNo:"",validateDonationStreetName:"",validateDonationVillageTown:"",validatestateSelected:"",
        validateDonationPinCode:"",validateCaptureMobileNo:"",validateCaptureOTP:""
    });

    console.log("data",this.state.donationInputObj)

    this.setState(Object.assign(this.state.donationInputObj,{volunteerMobileNo: this.state.volunteerMobileNoInput}));

    if(this.state.donationAmountValue != ""){
        if(this.state.donationAmountValue == 0 || this.state.donationAmountValue == ""){
            this.scrollTop();
            this.setState({validateDonationAmount:"Please Select Amount For Donaton"});
            return;
        }
    }else{
        if(this.state.donationAmountValue == 0 || this.state.donationAmountValue == "" ){
            this.scrollTop();
            this.setState({validateDonationAmount:"Please Enter Amount For Donaton"});
            return;
        }
    }

    /*if(this.state.donationAmountValue > 99){
        if(this.state.donationPanNumber =="" ){
            this.scrollTop();
            this.setState({validatePanCardNumber:"Please Enter PanCard Number"});
            return;
        }

        let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
        if (!regex.test(this.state.donationPanNumber)) {
            this.scrollTop();
            this.setState({validatePanCardNumber:"Please Enter Valid PanCard Number"});
            return;
        }
       
    }else{
        if(this.state.donationPanNumber != "" ){
            this.scrollTop();
            let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
            if (!regex.test(this.state.donationPanNumber)) {
                this.scrollTop();
                this.setState({validatePanCardNumber:"Please Enter Valid PanCard Number"});
                return;
            }
        }
    }*/

    this.setState(Object.assign(this.state.donationInputObj,{amount: this.state.donationAmountValue,panNumber:this.state.donationPanNumber}));
    
    if(this.state.haveMemberShipIdCheck == true){
        if(this.state.stateSelected == "" ){
            this.setState({validatestateSelected:"Please Select State"});
            return;
        }

        this.setState(Object.assign(this.state.donationInputObj,{stateId: this.state.stateSelected}));

        if(this.state.captureMobileNo == ""){
            this.setState({validateCaptureMobileNo:"Please Enter Mobile No"});
            return;
        }
        if(!this.state.captureMobileNo.match(/^[0-9]+$/)){
            this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No"});
            return;
        }
    
        if(this.state.captureMobileNo.length < 10){
            this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No"});
            return;
        }
    
        if(this.state.captureMobileNo != ""){
            if(this.state.captureOTPNO == ""){
                this.setState({validateCaptureOTP:"Please Enter OTP"});
                return;
            }
    
            if(this.state.captureOTPNO.length < 6){
                this.setState({validateCaptureOTP:"Please Enter Valid OTP"});
                return;
            }
    
            if(this.state.otpVerifiedMessageStatus == "NotVerified"){
                this.setState({validateCaptureOTP:"Please Enter Valid OTP"});
                return;
            }
        }

        this.setState(Object.assign(this.state.donationInputObj,{mobileNo: this.state.captureMobileNo}));

    }else if(this.state.noMemberShipIdCheck == true){

        if(this.state.donationName =="" ){
            this.scrollTop();
            this.setState({validateDonationName:"Please Enter Name"});
            return;
        }
        if(this.state.donationHouseNo =="" ){
            this.scrollTop();
            this.setState({validateDonationHouseNo:"Please Enter House No/Apartment"});
            return;
        }
        if(this.state.donationStreetName =="" ){
            this.scrollTop();
            this.setState({validateDonationStreetName:"Please Enter Street"});
            return;
        }
        if(this.state.donationVillageTown =="" ){
            this.scrollTop();
            this.setState({validateDonationVillageTown:"Please Enter Village/Town"});
            return;
        }
        if(this.state.stateSelected =="" ){
            this.scrollTop();
            this.setState({validatestateSelected:"Please Select State"});
            return;
        }
        
        if(this.state.stateSelected =="1" ){
            if(this.state.constituencySelected =="" ){
                this.scrollTop();
                this.setState({validateconstituencySelected:"Please Select Constituency"});
                return;
            }
        }else if(this.state.stateSelected =="36"){
            if(this.state.telconstituencySelected =="" ){
                this.scrollTop();
                this.setState({validateconstituencySelected:"Please Select Constituency"});
                return;
            }
        }else if(this.state.stateSelected =="0"){
            if(this.state.otherStateConstituencyName =="" ){
                this.scrollTop();
                this.setState({validateconstituencySelected:"Please Enter Constituency"});
                return;
            }
        }
       

        if(this.state.donationPinCode =="" ){
            this.scrollTop();
            this.setState({validateDonationPinCode:"Please Enter Pincode"});
            return;
        }

        this.setState(Object.assign(this.state.donationInputObj,{
            donarName : this.state.donationName,
            stateId : this.state.stateSelected,
            houseNo:this.state.donationHouseNo,
            streetName:this.state.donationStreetName,
            villageName:this.state.donationVillageTown,
            constituencyId:this.state.constituencySelected,
            constituencyName:this.state.constituencySelectedValue.label,
            pincode:this.state.donationPinCode
        }));


        if(this.state.captureMobileNo == ""){
            this.setState({validateCaptureMobileNo:"Please Enter Mobile No"});
            return;
        }
        if(!this.state.captureMobileNo.match(/^[0-9]+$/)){
            this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No"});
            return;
        }

        if(this.state.captureMobileNo.length < 10){
            this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No"});
            return;
        }

        if(this.state.captureMobileNo != ""){
            if(this.state.captureOTPNO == ""){
                this.setState({validateCaptureOTP:"Please Enter OTP"});
                return;
            }

            if(this.state.captureOTPNO.length < 6){
                this.setState({validateCaptureOTP:"Please Enter Valid OTP"});
                return;
            }

            if(this.state.otpVerifiedMessageStatus == "NotVerified"){
                this.setState({validateCaptureOTP:"Please Enter Valid OTP"});
                return;
            }
        }
        this.setState(Object.assign(this.state.donationInputObj,{mobileNo: this.state.captureMobileNo}));
    }

    
console.log("this.state.donationInputObj",this.state.donationInputObj)
    

    this.setState({paynowDonationButtonLoadingSymbol:"show"});   

    this.setState({paynowDonationButtonDisabled:true});

    setTimeout(() => {
        getAPICallDataForCadreSaving(JSON.stringify(this.state.donationInputObj),"saveCadreDonationDetails")
        .then((res) => res.json())
        .then((content) => {
            this.setState({paynowDonationButtonLoadingSymbol:"hide"});  
            this.setState({paynowDonationSuccessMessage:content.status});
            setTimeout(() => {
                //this.setState({paynowDonationSuccessMessage:"Redirect To Payment Page..."});
                //this.setState({paynowDonationButtonDisabled:false});
            }, 500);
    
            if(content !=null && content.status == "Success"){
                //this.setState({paynowDonationSuccessMessage:"Redirect To Payment Page..."});
                setTimeout(() => {
                    this.startTransactionForIciciGatewayForDonation(content.donationId);
                }, 2000);
            }else if(content !=null && content.saveStatus == "Fail"){
                this.setState({paynowDonationSuccessMessage:content.message});
        
            }else{
                this.setState({paynowDonationSuccessMessage:"Some Thing Went Wrong,Please Try Again..."});
        
            }
        });
        }, 1000);

}


startTransactionForIciciGatewayForDonation = (donationId) => {
    //event.preventDefault();

    const queryParams = new URLSearchParams({
        "amount" : this.state.donationInputObj.amount,
        "mobileNo" : this.state.donationInputObj.mobileNo,
        "source" : "TBot",
        "personName" : this.state.donationInputObj.donarName,
        "emailId" : "",
        "paymentModuleId" : 5,
        "tdpCadreId" : this.state.donationInputObj.cid,
        "panNumber" : this.state.donationInputObj.panNumber == undefined ? "" : this.state.donationInputObj.panNumber,
        "donationId":donationId,
        "volunteerMobileNo" : this.state.volunteerMobileNoInput
      }).toString();
  
      // Append query parameters to URL (replace `example.com` with your desired base URL)
      //http://tdp1.in/CR/WebService/PG/startTxnForIciciGateway?amount=1&mobileNo=9966542524&source=TBot&personName=Mahesh&emailId=maheshkommineni9@gmail.com&paymentModuleId=4&tdpCadreId=18507524&panNumber=APBHP2345H

      const url = `http://tdp1.in/CR/WebService/PG/startTxnForIciciGateway?${queryParams}`;

      console.log(url)
  
      // Redirect to the constructed URL (or use React Router for navigation)
      window.location.href = url;

}

typeOfLanguageSelectionNew = (e,languageType) => {
   
    if(languageType == "english"){
        this.setState({englishSelected:true,teleguSelected:false})
    }else{
        this.setState({englishSelected:false,teleguSelected:true})
    }
}

    render() {
        
       
        return (
           <section>
                <div className="header_cadre_img"></div>
                    <Container>
                    
                    <Row>
                        <Col sm={12}>
                        <div className='flex-back-lang'>
                            <div>
                            <Button variant="outline-dark pad5_14" className='f-12 fw-bold mt-2' onClick={() => this.backToNewCadreEnrollPage()}> <i class="fa-solid fa-arrow-left"></i> Home</Button> 
                            </div>
                            <div>
                                <Form>
                                    <div className='float-end mt-2'>
                                    <Form.Check
                                        inline
                                        label={`English Version`}
                                        name="languageSelectionNew"
                                        type="radio"
                                        id={`englishddVersionId`}
                                        onChange={(e)=>this.typeOfLanguageSelectionNew(e,"english")}
                                        className="f-12 fw-bold color_red cursor_pointer"
                                        value="english"
                                        checked={this.state.englishSelected}
                                    />
                                    <Form.Check
                                        inline
                                        label={`తెలుగు వెర్షన్`}
                                        name="languageSelectionNew"
                                        type="radio"
                                        id={`teleguddVersionId`}
                                        onChange={(e)=>this.typeOfLanguageSelectionNew(e,"telegu")}
                                        className="f-12 fw-bold color_red cursor_pointer"
                                        value="telegu"
                                        checked={this.state.teleguSelected}
                                    />
                                    </div>
                                </Form>
                            </div>
                        </div>
                         

                            
                                
                        </Col>
                    </Row>


                    <Row>
                        <Col>
                            <h6 className='text-center color_green fw-bold  mt-3'>{this.state.englishSelected== true ? <span className='border-bottom-double'>Donation</span> : <span className='border-bottom-double'>డొనేషన్</span>}</h6>
                        </Col>
                    </Row>

                    {
                        this.state.donationFirstPage == true ?
                        (
                            <>
                            <Row>
                                <Col>
                                    <div className='bg_white_shadow_border mt-3'>
                                        <h6 className='text-center'>{this.state.englishSelected== true ? "Do You Have MemberShip Id?" : "మీకు సభ్యత్వం ఉందా ?"}</h6>
                                        <Row >
                                            <Col className='text-center mt-2'>
                                                <Button variant="outline-success" className={this.state.haveMemberShipIdCheck == true ? "f-14 fw-bold active_checked" : "f-14 fw-bold"} onClick={() => this.haveMemberShipIdClick("yes")}> {this.state.englishSelected== true ? "YES" : "వుంది" } <i class="fa-solid fa-circle-check m_left_8"></i></Button>
                                                <Button variant="outline-success" className={this.state.noMemberShipIdCheck == true ? "f-14 mr_10 fw-bold active_checked" : "f-14 mr_10 fw-bold"} onClick={() => this.haveMemberShipIdClick("no")}> {this.state.englishSelected== true ? "NO" : "లేదు" } <i class="fa-solid fa-circle-xmark m_left_8"></i></Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            {
                                this.state.haveMemberShipIdCheck == true ?
                                (
                                    
                                    <fieldset class=""><legend>{this.state.englishSelected== true ? "Membership Is Available" : "సభ్యత్వం వుంది :"}  </legend> 
                                    <Row >
                                        <Col >
                                            <div className='mt-2'>
                                                <Col sm={12} className='mt-2'>
                                                    <label className="form-label form-label-block f-12 fw-bold">{this.state.englishSelected== true ? "MEMBERSHIP ID" : "సభ్యత్వ నెంబర్"} </label>
                                                    <input type="text" className='form-control' name="searchRenewalMembershipId" placeholder='Enter MEMBERSHIP ID' maxLength={8} value={this.state.searchRenewalMembershipId} onChange={(e) => this.handleOnchangeInputBox(e)}></input>
                                                </Col>
                                                <Col sm={12} className='mt-2'>
                                                    <label className="form-label form-label-block f-12 fw-bold">(OR) {this.state.englishSelected== true ? "MOBILE NO" : "మొబైల్ నెంబర్"} </label>
                                                    <input type="text" className='form-control' name="searchRenewalMobileNo" placeholder='Enter MOBILE NO'maxLength={10} value={this.state.searchRenewalMobileNo} onChange={(e) => this.handleOnchangeInputBox(e)}></input>
                                                </Col>
                                                <Col sm={12} className='mt-2'>
                                                    <label className="form-label form-label-block f-12 fw-bold">(OR) {this.state.englishSelected== true ? "VOTER NO" : "ఓటరు నెంబర్"} </label>
                                                    <input type="text" className='form-control' name="searchRenewalVoterId" placeholder='Enter VOTER ID' value={this.state.searchRenewalVoterId} onChange={(e) => this.handleOnchangeInputBox(e)}></input>
                                                </Col>
                                                <p className='mt-1 f-12 error_cls_new'>{this.state.userDetailsError}</p>
                                                <Button variant="success" className='f-12 fw-bold center-auto mt-2' onClick={(e) => this.submitUserIds(e)} >{this.state.englishSelected== true ? "SUBMIT" : "SUBMIT"} </Button>
        
                                            </div>
                                        </Col>
                                    </Row>
                                    
                                        {
                                            this.state.renewalDetailsLoading == "show" ?
                                            (
                                                <Row>
                                                    <Col sm={12}>
                                                        <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                                    </Col>
                                                </Row>
                                            )
                                            :
                                            ("")
                                        }
                                        {
                                            this.state.renewalDetailsArr.length > 0 ?
                                            (
                                                
                                                <>
                                                
                                                    {
                                                        this.state.renewalDetailsArr.map((item,index) => {
                                                            return(
                                                                <Row>
                                                                    <Col>
                                                                        <div className="border_yash_pad mt-2">
                                                                            <h6 className='f-12'>{this.state.englishSelected== true ? "Name" : "పేరు"} : {item.cname}</h6>
                                                                            <h6 className='f-12'>{this.state.englishSelected== true ? "Membership No" : "సభ్యత్వం నెంబర్"}  : {item.mid}</h6>
                                                                            <h6 className='f-12 mt-2'>{this.state.englishSelected== true ? "Voter No" : "ఓటరు నెంబర్"} : {item.vno}</h6>
                                                                            <h6 className='f-12 mt-2'>{this.state.englishSelected== true ? "Relative Name " : "బంధువు పేరు"}  : {item.relativeName} |  {this.state.englishSelected== true ? "Relation" : "సంబంధం"}  : {item.relation}</h6>
                                                                            <h6 className='f-12 mt-2'>{this.state.englishSelected== true ? "H.NO " : "ఇంటి నెంబర్"} :{item.houseNo}  |  {this.state.englishSelected== true ? "Gender " : "లింగం"} : {item.gender}  |  {this.state.englishSelected== true ? "Age " : "వయస్సు"} :{item.age}</h6>
        
                                                                            <Row>
                                                                                <Col>
                                                                                    <h6 className='f-14 fw-bold float-end text-decoration-underline color_red cursor_pointer' onClick={() => this.donationSecondPageView(item)}>Use This Member To Donation Now</h6>
                                                                                </Col>
                                                                            </Row>
        
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                            
                                                        })
                                                    }
                                                    
                                                </>
                                            )
                                            :
                                            (<>
                                                {
                                                this.state.renewalDetailsDataCheck == 1 ?
                                                (<h6 className='f-14 text-center mt-4'>No Data Availble...</h6>)
                                                :
                                                ("")
                                            }
                                            </>)
                                        }
                                        </fieldset>
                                                
                                        
                                )
                                :
                                (
                                    
                                    this.state.noMemberShipIdCheck == true ?
                                    (
                                        <>
                                       <Row>
                                          <Col>
                                                <h6 className='f-14 mt-3 text-center fw-bold'>{this.state.englishSelected== true ? "Membership Is Not Available :" : "సభ్యత్వం లేదు :"}  </h6>
                                          </Col>
                                       </Row>
                                       <div className='scroll_top_mobile'></div>

                                        <fieldset class=""><legend>{this.state.englishSelected== true ? "Donation Amount" : "విరాళం"}</legend> 
                                            <h6 className='mt-3 f-14 ln-25'>{this.state.englishSelected== true ? "You Can Specify The Amount You Wish To Donate :" : "మీరు విరాళం (డొనేషన్) చేయదలచుకున్న మొత్తం ని తెలియజేయగలరు ?"}</h6>

                                            <Row>
                                                <Col>
                                                    <div className="mt-1">
                                                        <Form.Check
                                                                inline
                                                                label={"99"}
                                                                name="donationName"
                                                                type="radio"
                                                                id={`donationOneId`}
                                                                className="f-14 fw-bold color_black cursor_pointer"
                                                                value="99"
                                                                onChange={(e)=>this.donationAmountSeletedType(e,"99")}
                                                        ></Form.Check>
                                                        <Form.Check
                                                                inline
                                                                label={"999"}
                                                                name="donationName"
                                                                type="radio"
                                                                id={`donationtwoId`}
                                                                className="f-14 fw-bold color_black cursor_pointer"
                                                                value="999"
                                                                onChange={(e)=>this.donationAmountSeletedType(e,"999")}
                                                        ></Form.Check>
                                                        <Form.Check
                                                                inline
                                                                label={"9999"}
                                                                name="donationName"
                                                                type="radio"
                                                                id={`donationThreeId`}
                                                                className="f-14 fw-bold color_black cursor_pointer"
                                                                value="9999"
                                                                onChange={(e)=>this.donationAmountSeletedType(e,"9999")}
                                                        ></Form.Check>
                                                        <Form.Check
                                                                inline
                                                                label={"19999"}
                                                                name="donationName"
                                                                type="radio"
                                                                id={`donationFourId`}
                                                                className="f-14 fw-bold color_black cursor_pointer"
                                                                value="19999"
                                                                onChange={(e)=>this.donationAmountSeletedType(e,"19999")}
                                                        ></Form.Check>
                                                        <Form.Check
                                                                inline
                                                                label={"99999"}
                                                                name="donationName"
                                                                type="radio"
                                                                id={`donationFiveId`}
                                                                className="f-14 fw-bold color_black cursor_pointer"
                                                                value="99999"
                                                                onChange={(e)=>this.donationAmountSeletedType(e,"99999")}
                                                        ></Form.Check>
                                                        <Form.Check
                                                                inline
                                                                label={"Other Amount"}
                                                                name="donationName"
                                                                type="radio"
                                                                id={`donationSixId`}
                                                                className="f-14 fw-bold color_black cursor_pointer"
                                                                value="other_amount"
                                                                onChange={(e)=>this.donationAmountSeletedType(e,"other_amount")}
                                                        ></Form.Check>
                                                    
                                                    </div>
                                                </Col>
                                            </Row>

                                            {
                                                this.state.otherDonationAmount == true ?
                                                (
                                                    <Row>
                                                        <Col className='mt-2'>
                                                            <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Enter Amount" : "Enter Amount"} <span className='color_red f-14 ms-1'>*</span></h6>
                                                            <Form.Control type="text" name="donationAmountValue" value={this.state.donationAmountValue}  className='form-control-sm'  placeholder="Enter Amount" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)}  onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                        </Col>
                                                    </Row>
                                                )
                                                :
                                                ("")
                                            }

                                            {
                                                this.state.validateDonationAmount != "" ?
                                                (
                                                    <Row>
                                                        <Col>
                                                            <h6 className='color_red f-12 mt-3'>{this.state.validateDonationAmount}</h6>
                                                        </Col>
                                                    </Row>
                                                )
                                                :
                                                ("")
                                                
                                            }

                                            {/*<Row>
                                                <Col className='mt-3'>
                                                    <h6 className="form-label f-12 fw-bold"> {this.state.englishSelected== true ? "Pan Card Number" : "పాన్ నంబర్"} </h6>
                                                    <Form.Control type="text" name="donationPanNumber" value={this.state.donationPanNumber}  className='form-control-sm'  placeholder="Enter PanNumber" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                </Col>
                                            </Row>*/}

                                            {
                                                this.state.validatePanCardNumber != "" ?
                                                (
                                                    <Row>
                                                        <Col>
                                                            <h6 className='color_red f-12 mt-3'>{this.state.validatePanCardNumber}</h6>
                                                        </Col>
                                                    </Row>
                                                )
                                                :
                                                ("")
                                                
                                            }
                                        </fieldset>

                                        <fieldset class=""><legend>{this.state.englishSelected== true ? "Person Details" : "వ్యక్తి వివరాలను నమోదు చేయండి"}</legend> 
                                            
                                            <Row>
                                                <Col className='mt-2'>
                                                    <h6 className="form-label f-12"> {this.state.englishSelected== true ? "Name" : "పేరు"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validateDonationName}</span></h6>
                                                    <Form.Control type="text" name="donationName"  className='form-control-sm'  placeholder="Enter Name" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className='mt-2'>
                                                    <h6 className="form-label f-12"> {this.state.englishSelected== true ? "House No/Apartment Name" : "ఇంటి నెంబర్/అపార్ట్‌మెంట్ పేరు"} <span className='color_red f-12 ms-1'>*</span> <span className='color_red f-14 ms-1'>{this.state.validateDonationHouseNo}</span></h6>
                                                    <Form.Control type="text" name="donationHouseNo"  className='form-control-sm'  placeholder="Enter House No" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className='mt-2'>
                                                    <h6 className="form-label f-12"> {this.state.englishSelected== true ? "Street Name" : "వీధి పేరు"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validateDonationStreetName}</span></h6>
                                                    <Form.Control type="text" name="donationStreetName"  className='form-control-sm'  placeholder="Enter Street Name" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                </Col>

                                                <Col className='mt-2'>
                                                    <h6 className="form-label f-12"> {this.state.englishSelected== true ? "Village/Town" : "గ్రామం/పట్టణం"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validateDonationVillageTown}</span></h6>
                                                    <Form.Control type="text" name="donationVillageTown"  className='form-control-sm'  placeholder="Enter Village/Town" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className='mt-2'>
                                                    <h6 className="form-label f-12"> {this.state.englishSelected== true ? "State" : "రాష్ట్రం"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validatestateSelected}</span> </h6>
                                                    <SelectBox
                                                        stateData={this.state.stateSelectedValue}
                                                        handleChange={this.handleOnchangeSelectBoxNew}
                                                        name="stateSelected"
                                                        options={this.state.stateSelectedArr}
                                                        placeholderName={'Select State'}
                                                        dropdownIndicator={{ DropdownIndicator }}
                                                    />
                                                </Col>

                                                <Col className='mt-2'>
                                                    <h6 className="form-label f-12"> {this.state.englishSelected== true ? "Constituency" : "నియోజకవర్గం"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validateconstituencySelected}</span> </h6>
                                                    {
                                                        this.state.stateSelected == "1" ?
                                                        (
                                                            <SelectBox
                                                                stateData={this.state.constituencySelectedValue}
                                                                handleChange={this.handleOnchangeSelectBoxNew}
                                                                name="constituencySelected"
                                                                options={this.state.constituencySelectedArr}
                                                                placeholderName={'Constituency'}
                                                                dropdownIndicator={{ DropdownIndicator }}
                                                            />
                                                        )
                                                        :
                                                        (
                                                            this.state.stateSelected == "36" ? 
                                                            (
                                                                <SelectBox
                                                                    stateData={this.state.telconstituencySelectedValue}
                                                                    handleChange={this.handleOnchangeSelectBoxNew}
                                                                    name="telconstituencySelected"
                                                                    options={this.state.telconstituencySelectedArr}
                                                                    placeholderName={'Constituency'}
                                                                    dropdownIndicator={{ DropdownIndicator }}
                                                                />
                                                            )
                                                            :
                                                            (
                                                                this.state.stateSelected == "37" ? 
                                                                (
                                                                    <Form.Control type="text" name="otherStateConstituencyName"  className='form-control-sm'  placeholder="Enter Constituency Name" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                                )
                                                                :
                                                                ("")
                                                            )
                                                        )
                                                    }
                                                    
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className='mt-2'>
                                                    <h6 className="form-label f-12"> {this.state.englishSelected== true ? "PinCode" : "పిన్‌కోడ్"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-14 ms-1'>{this.state.validateDonationPinCode}</span></h6>
                                                    <Form.Control type="text" name="donationPinCode" maxLength={6} className='form-control-sm'  placeholder="Enter Pincode" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                </Col>
                                            </Row>


                                        </fieldset>

                                        <ChangeMobileNoOTPValidation 
                                            stateData={this.state}
                                            handleOnchangeInputBox={this.handleOnchangeInputBox}
                                            getMobileNoOTP={this.getMobileNoOTP}
                                            resendOTPNew={this.resendOTPNew}
                                            handleOnchangeAllowNumbersInputBox={this.handleOnchangeAllowNumbersInputBox}
                                            changeMobileNo={this.changeMobileNo}
                                        />

                                            <Row>
                                                    <Col sm={12}>
                                                    
                                                        <Button variant="danger" className="red_button_event center-auto mt-4" disabled={this.state.paynowDonationButtonDisabled} onClick={() => this.donationWithOutMemberShip()}>PAY NOW
                                                        
                                                            {
                                                                this.state.paynowDonationButtonLoadingSymbol == "show" ? 
                                                                (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image>)
                                                                :
                                                                ("")
                                                            }
                                                         </Button>

                                                        {
                                                            this.state.paynowDonationSuccessMessage == "Success" ?
                                                            (<h6 className='text-center f-14 color_green mt-5 fw-bold'>Redirect To Payment Page...</h6>)
                                                            :
                                                            (
                                                                <h6 className='text-center f-14 color_red mt-5 fw-bold'>{this.state.paynowDonationSuccessMessage}</h6>
                                                                
                                                            )
                                                        }
                                                        
                                                    

                                                        
                                                        
                                                    </Col>
                                                </Row>

                                        </>

                                    )
                                    :
                                    ("")
                                    
                                    
                                )
                            }
                            </>
                        )
                        :
                        (
                            this.state.donationSecondPage == true ? 
                            (
                                <>

                                <Row>
                                    <Col>
                                        <Button variant="outline-dark pad5_14" className='f-12 fw-bold float-end mt-2' onClick={() => this.donationPreviousPage()}> <i class="fa-solid fa-arrow-left"></i> Back</Button> 
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <h6 className='f-12 fw-bold'>{this.state.englishSelected== true ? "Donar Name" : "దాత పేరు"} : {this.state.donationInputObj.donarName}</h6>
                                    </Col>
                                </Row>
                                <div className='scroll_top_mobile'></div>

                                <fieldset class=""><legend>{this.state.englishSelected== true ? "Donation Amount" : "విరాళం"}</legend>  

                                    <h6 className='mt-3 f-14 ln-25'>{this.state.englishSelected== true ? "You Can Specify The Amount You Wish To Donate :" : "మీరు విరాళం (డొనేషన్) చేయదలచుకున్న మొత్తం ని తెలియజేయగలరు ?"}</h6>

                                        <Row>
                                            <Col>
                                                <div className="mt-1">
                                                    <Form.Check
                                                            inline
                                                            label={"99"}
                                                            name="donationName"
                                                            type="radio"
                                                            id={`donationOneId`}
                                                            className="f-14 fw-bold color_black cursor_pointer"
                                                            value="99"
                                                            onChange={(e)=>this.donationAmountSeletedType(e,"99")}
                                                    ></Form.Check>
                                                    <Form.Check
                                                            inline
                                                            label={"999"}
                                                            name="donationName"
                                                            type="radio"
                                                            id={`donationtwoId`}
                                                            className="f-14 fw-bold color_black cursor_pointer"
                                                            value="999"
                                                            onChange={(e)=>this.donationAmountSeletedType(e,"999")}
                                                    ></Form.Check>
                                                    <Form.Check
                                                            inline
                                                            label={"9999"}
                                                            name="donationName"
                                                            type="radio"
                                                            id={`donationThreeId`}
                                                            className="f-14 fw-bold color_black cursor_pointer"
                                                            value="9999"
                                                            onChange={(e)=>this.donationAmountSeletedType(e,"9999")}
                                                    ></Form.Check>
                                                    <Form.Check
                                                            inline
                                                            label={"19999"}
                                                            name="donationName"
                                                            type="radio"
                                                            id={`donationFourId`}
                                                            className="f-14 fw-bold color_black cursor_pointer"
                                                            value="19999"
                                                            onChange={(e)=>this.donationAmountSeletedType(e,"19999")}
                                                    ></Form.Check>
                                                    <Form.Check
                                                            inline
                                                            label={"99999"}
                                                            name="donationName"
                                                            type="radio"
                                                            id={`donationFiveId`}
                                                            className="f-14 fw-bold color_black cursor_pointer"
                                                            value="99999"
                                                            onChange={(e)=>this.donationAmountSeletedType(e,"99999")}
                                                    ></Form.Check>
                                                    <Form.Check
                                                            inline
                                                            label={"Other Amount"}
                                                            name="donationName"
                                                            type="radio"
                                                            id={`donationSixId`}
                                                            className="f-14 fw-bold color_black cursor_pointer"
                                                            value="other_amount"
                                                            onChange={(e)=>this.donationAmountSeletedType(e,"other_amount")}
                                                    ></Form.Check>
                                                
                                                </div>
                                            </Col>
                                        </Row>

                                        {
                                            this.state.otherDonationAmount == true ?
                                            (
                                                <Row>
                                                    <Col className='mt-2'>
                                                        <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Enter Amount" : "Enter Amount"} <span className='color_red f-14 ms-1'>*</span></h6>
                                                        <Form.Control type="text" name="donationAmountValue" value={this.state.donationAmountValue}  className='form-control-sm'  placeholder="Enter Amount" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)}  onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                    </Col>
                                                </Row>
                                            )
                                            :
                                            ("")
                                        }

                                        {
                                            this.state.validateDonationAmount != "" ?
                                            (
                                                <Row>
                                                    <Col>
                                                        <h6 className='color_red f-12 mt-3'>{this.state.validateDonationAmount}</h6>
                                                    </Col>
                                                </Row>
                                            )
                                            :
                                            ("")
                                            
                                        }

                                       {/* <Row>
                                            <Col className='mt-3'>
                                                <h6 className="form-label f-12 fw-bold"> {this.state.englishSelected== true ? "Pan Card Number" : "పాన్ నంబర్"} </h6>
                                                <Form.Control type="text" name="donationPanNumber" value={this.state.donationPanNumber}  className='form-control-sm'  placeholder="Enter PanNumber" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                            </Col>
                                        </Row>*/}

                                        {
                                            this.state.validatePanCardNumber != "" ?
                                            (
                                                <Row>
                                                    <Col>
                                                        <h6 className='color_red f-12 mt-3'>{this.state.validatePanCardNumber}</h6>
                                                    </Col>
                                                </Row>
                                            )
                                            :
                                            ("")
                                            
                                        }
                                                    
                                    </fieldset>

                                    <Row>
                                        <Col className='mt-3'>
                                            <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "State" : "రాష్ట్రం"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validatestateSelected}</span> </h6>
                                            <SelectBox
                                                stateData={this.state.stateSelectedValue}
                                                handleChange={this.handleOnchangeSelectBoxNew}
                                                name="stateSelected"
                                                options={this.state.stateSelectedArr}
                                                placeholderName={'Select State'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                        </Col>
                                    </Row>

                                    <ChangeMobileNoOTPValidation 
                                        stateData={this.state}
                                        handleOnchangeInputBox={this.handleOnchangeInputBox}
                                        getMobileNoOTP={this.getMobileNoOTP}
                                        resendOTPNew={this.resendOTPNew}
                                        handleOnchangeAllowNumbersInputBox={this.handleOnchangeAllowNumbersInputBox}
                                        changeMobileNo={this.changeMobileNo}
                                    />

                                    <Row>
                                        <Col sm={12}>
                                        
                                            <Button variant="danger" className="red_button_event center-auto mt-4" disabled={this.state.paynowDonationButtonDisabled} onClick={() => this.paymentSuccessMessage()}>PAY NOW 
                                            
                                            {
                                                this.state.paynowDonationButtonLoadingSymbol == "show" ? 
                                                (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image>)
                                                :
                                                ("")
                                            }
                                            </Button>
                                            {
                                                this.state.paynowDonationSuccessMessage == "Success" ?
                                                (<h6 className='text-center f-14 color_green mt-5 fw-bold'>Redirect To Payment Page...</h6>)
                                                :
                                                (
                                                    <h6 className='text-center f-14 color_red mt-5 fw-bold'>{this.state.paynowDonationSuccessMessage}</h6>
                                                    
                                                )
                                            }
                                            
                                        </Col>
                                    </Row>


                                

                                </>

                            )
                            :
                            ("")
                        )
                    }

                    

                </Container>
           </section>
        )
    }
  }
  
  export default withRouter(DonationAmountPage);
  